import { render, staticRenderFns } from "./PortalUsers.vue?vue&type=template&id=3cd2dccf&"
import script from "./PortalUsers.ts?vue&type=script&lang=ts&"
export * from "./PortalUsers.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports